import { motion as Motion, useScroll, useSpring } from 'motion/react';

// The slim progress rail gives long-form browsing a clear sense of position.
export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 32, mass: 0.2 });

  return <Motion.div className="scroll-progress" style={{ scaleX }} aria-hidden="true" />;
}
